import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedMaterialModule } from './../shared-material/shared-material.module';
import { AprendeComponent } from './aprende/aprende.component';
import { CargaComponent } from './carga/carga.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CotizadorComponent } from './cotizador/cotizador.component';
import { FinalTransaccionComponent } from './final-transaccion/final-transaccion.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { AyudaComponent } from './inicio-n/ayuda/ayuda.component';
import { BeneficiosComponent } from './inicio-n/beneficios/beneficios.component';
import { BilleteraComponent } from './inicio-n/billetera/billetera.component';
import { BlogComponent } from './inicio-n/blog/blog.component';
import { DetalleBComponent } from './inicio-n/blog/detalle-b/detalle-b.component';
import { FooterNComponent } from './inicio-n/footer-n/footer-n.component';
import { HeaderNComponent } from './inicio-n/header-n/header-n.component';
import { HomeComponent } from './inicio-n/home/home.component';
import { InicioNComponent } from './inicio-n/inicio-n.component';
import { LoginMobileComponent } from './inicio-n/login-mobile/login-mobile.component';
import { LoginComponent, ModalLoginTest } from './inicio-n/login/login.component';
import { ModalRegComponent } from './inicio-n/modal-reg/modal-reg.component';
import { Registro2Component } from './inicio-n/registro2/registro2.component';
import { InicioComponent } from './inicio/inicio.component';
import { IpVerificaComponent } from './ip-verifica/ip-verifica.component';
import { Login2Component } from './login2/login2.component';
import { Login3Component } from './login3/login3.component';
import { NivelesComponent } from './niveles/niveles.component';
import { NosotrosComponent } from './nosotros/nosotros.component';
import { PrincipalComponent } from './principal/principal.component';

@NgModule({
  declarations: [
    InicioComponent,
    PrincipalComponent,
    HeaderComponent,
    CargaComponent,
    FooterComponent,
    NosotrosComponent,
    Login2Component,
    AprendeComponent,
    Login3Component,
    NivelesComponent,
    InicioNComponent,
    HeaderNComponent,
    HomeComponent,
    FooterNComponent,
    BeneficiosComponent,
    LoginComponent,
    AyudaComponent,
    BlogComponent,
    DetalleBComponent,
    BilleteraComponent,
    Registro2Component,
    ModalRegComponent,
    LoginMobileComponent,
    FinalTransaccionComponent,
    CheckoutComponent,
    IpVerificaComponent,
    CotizadorComponent,
    ModalLoginTest
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    SharedMaterialModule,
    NgxSpinnerModule,
    MatSnackBarModule,
    IvyCarouselModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatFormFieldModule,
    MatIconModule,
    MatCheckboxModule,
    MatTooltipModule
  ],
  exports: [InicioComponent, HeaderComponent, HeaderNComponent, FooterNComponent, FooterComponent, NivelesComponent, ModalRegComponent],
  providers: [MatProgressSpinnerModule,]
})
export class LayoutModule { }
